import yup from "src/validators/yup.Module";

export interface ProdutoFiltrarDto {
  nome: string;
}

export interface ProdutoDto {
  id: number;
  codigoProduto: string;
  codigoBarras: string;
  nome: string;
  descricao: string;
  valorUnitarioComercial: number;
  categoriaId: number;
  categoriaNome: string;
  codigoNCM: string;
  unidadeComercial: string;
}

export const ProdutoFiltrarSchema = yup.object().shape({
  // nome: yup
  // .string()
  // .notRequired()
  // .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
